import React from 'react';
import { ConfirmDialog } from '@/components/ui';

export interface HeConfirmModalProps {
  show: boolean;
  title: string;
  children: React.ReactNode;
  confirmLabel: string;
  cancelLabel?: string;
  confirmVariant?: 'primary' | 'danger' | 'success';
  busy?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

/**
 * Hired equipment's yes/no confirmation (M13 discard, C4 amount change). Now a thin wrapper over
 * the shared ConfirmDialog (V2-016) so there is one confirmation dialog in the app.
 */
const HeConfirmModal: React.FC<HeConfirmModalProps> = ({ children, ...props }) => (
  <ConfirmDialog {...props}>{children}</ConfirmDialog>
);

export default HeConfirmModal;
